export default "__VITE_ASSET__24b85496__"